export const TOTAL_KEY = "#{#TT#}#";

export declare interface DimensionNode {
  value: string;
  label: string;
  index: number;
  span: number;
  total: boolean;
}

export declare interface ReportResult {
  // 数据数组, KEY为数据索引, 值为按指标值按顺序组成的数据
  dataValues: Array<Array<number>>;

  // 输出表格结果的总行数(包括统计的行)
  rowCount: number;

  // 输出表格结果的总列数(包括统计的列, 但多个指标时算一列,即真正的总列数要乘上指标个数)
  colCount: number;

  // 通过行列值到数据的索引的二维数据, [行号][列号]=数据索引, 其中行列号从0开始, 数据索引也从0开始, 如果没有数据索引(-1),表示该行列没有数据
  rowColIndexes: Array<Array<number>>;

  // 行维度的数组, KEY为行号, 值为各级行维数组, 每个元素为 DimensionNode 对象
  rowDimNodes: Array<Array<DimensionNode>>;

  // 列维度的数组, KEY为列号, 值为各级列维数组, 每个元素为 DimensionNode 对象
  colDimNodes: Array<Array<DimensionNode>>;

  // 总的统计索引
  totalIndex: number;
}

export enum ChartType {
  LINE,
  BAR,
  GEO,
  PIE,
  MATRIXPIE,
  HEATMAP,
}

export declare interface ChartOption {
  chartType: ChartType;
  title: string;
  subTitle: string;
  hideTitle: boolean;
  xaxisTitle: string;
  yaxisTitle: string;
  hideAxisTitle: boolean;
  hideLabel: boolean;
  hideLegend: boolean;
  hideToolbox: boolean;
}
